import React from 'react';
import { CheckCircle, Play, Phone, ArrowRight } from 'lucide-react';

const AboutSectionExactReplica = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .about-section-replica {
          padding: 8rem 2rem;
          background: linear-gradient(180deg, #E8F4F8 0%, #F5FAFE 50%, #FFFFFF 100%);
          position: relative;
          overflow: hidden;
        }

        /* Exact Triangle Pattern Background */
        .triangle-pattern {
          position: absolute;
          top: 0;
          left: 0;
          width: 45%;
          height: 100%;
          background-image: 
            repeating-linear-gradient(
              60deg,
              transparent,
              transparent 20px,
              rgba(98, 182, 203, 0.15) 20px,
              rgba(98, 182, 203, 0.15) 22px
            ),
            repeating-linear-gradient(
              -60deg,
              transparent,
              transparent 20px,
              rgba(98, 182, 203, 0.15) 20px,
              rgba(98, 182, 203, 0.15) 22px
            );
          pointer-events: none;
          z-index: 1;
        }

        /* Wavy Lines Background */
        .wave-pattern {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 45%;
          height: 60%;
          background-image: 
            repeating-radial-gradient(
              circle at 0% 100%,
              transparent 0,
              rgba(98, 182, 203, 0.08) 40px,
              transparent 80px
            );
          pointer-events: none;
          z-index: 1;
        }

        .about-container-replica {
          max-width: 1400px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 6rem;
          align-items: center;
          position: relative;
          z-index: 2;
        }

        /* Image Collage - Exact Layout */
        .images-collage-replica {
          position: relative;
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-template-rows: auto auto auto;
          gap: 1.5rem;
          height: 700px;
        }

        /* Large Image - Top Left */
        .image-large-left {
          grid-column: 1;
          grid-row: 1 / 3;
          position: relative;
          border-radius: 40px;
          overflow: hidden;
          background: white;
          padding: 8px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        /* Top Right Image */
        .image-top-right {
          grid-column: 2;
          grid-row: 1;
          position: relative;
          border-radius: 35px;
          overflow: hidden;
          background: white;
          padding: 8px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        /* Bottom Left Image */
        .image-bottom-left {
          grid-column: 1;
          grid-row: 3;
          position: relative;
          border-radius: 35px;
          overflow: hidden;
          background: white;
          padding: 8px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        /* Large Image - Bottom Right */
        .image-large-right {
          grid-column: 2;
          grid-row: 2 / 4;
          position: relative;
          border-radius: 40px;
          overflow: hidden;
          background: white;
          padding: 8px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        .image-inner {
          width: 100%;
          height: 100%;
          border-radius: 32px;
          overflow: hidden;
        }

        .collage-image-replica {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        /* Content Section */
        .about-content-replica {
          padding-left: 2rem;
        }

        .about-badge-replica {
          display: inline-flex;
          align-items: center;
          gap: 0.8rem;
          padding: 0.6rem 1.5rem;
          background: transparent;
          border: 2px solid #00BCD4;
          border-radius: 50px;
          color: #00BCD4;
          font-weight: 700;
          font-size: 0.85rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 2rem;
        }

        .badge-icon-replica {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .badge-icon-replica svg {
          stroke: #00BCD4;
          stroke-width: 2;
        }

        .about-title-replica {
          font-family: 'Inter', sans-serif;
          font-size: 3.5rem;
          font-weight: 800;
          color: #0A1F44;
          margin-bottom: 2rem;
          line-height: 1.2;
        }

        .about-description-replica {
          font-size: 1.05rem;
          color: #6B7280;
          line-height: 1.8;
          margin-bottom: 3rem;
          font-weight: 400;
        }

        /* Video and Features Section */
        .video-features-section {
          display: grid;
          grid-template-columns: 240px 1fr;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        /* Video Thumbnail */
        .video-thumbnail-replica {
          position: relative;
          width: 240px;
          height: 140px;
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .video-thumbnail-replica img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .video-play-replica {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 60px;
          height: 60px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
        }

        .video-play-replica svg {
          margin-left: 3px;
        }

        /* Features List */
        .features-list-replica {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .feature-item-replica {
          display: flex;
          align-items: center;
          gap: 1rem;
          font-size: 1.05rem;
          color: #0A1F44;
          font-weight: 600;
        }

        .check-icon-replica {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        /* CTA Section */
        .cta-section-replica {
          display: flex;
          align-items: center;
          gap: 2rem;
        }

        .about-button-replica {
          padding: 1.1rem 2.5rem;
          background: #00BCD4;
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 1rem;
          text-decoration: none;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 188, 212, 0.3);
        }

        .about-button-replica:hover {
          background: #00ACC1;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 188, 212, 0.4);
        }

        .arrow-circle {
          width: 36px;
          height: 36px;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .emergency-contact-replica {
          display: flex;
          align-items: center;
          gap: 1.2rem;
        }

        .phone-icon-wrapper {
          width: 56px;
          height: 56px;
          background: white;
          border: 2px solid #E5E7EB;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #00BCD4;
        }

        .emergency-text-replica {
          display: flex;
          flex-direction: column;
          gap: 0.2rem;
        }

        .emergency-label-replica {
          font-size: 0.85rem;
          color: #6B7280;
          font-weight: 500;
        }

        .emergency-number-replica {
          font-size: 1.4rem;
          font-weight: 800;
          color: #0A1F44;
          font-family: 'Inter', sans-serif;
        }

        /* Responsive */
        @media (max-width: 1200px) {
          .about-container-replica {
            gap: 4rem;
          }
        }

        @media (max-width: 1024px) {
          .about-container-replica {
            grid-template-columns: 1fr;
            gap: 4rem;
          }

          .triangle-pattern,
          .wave-pattern {
            width: 100%;
            height: 40%;
          }

          .about-content-replica {
            padding-left: 0;
          }
        }

        @media (max-width: 768px) {
          .about-section-replica {
            padding: 4rem 1.5rem;
          }

          .about-title-replica {
            font-size: 2.5rem;
          }

          .images-collage-replica {
            height: auto;
            grid-template-columns: 1fr;
            grid-template-rows: auto;
          }

          .image-large-left,
          .image-top-right,
          .image-bottom-left,
          .image-large-right {
            grid-column: 1;
            grid-row: auto;
            height: 250px;
          }

          .video-features-section {
            grid-template-columns: 1fr;
          }

          .video-thumbnail-replica {
            width: 100%;
            max-width: 300px;
            margin: 0 auto;
          }

          .cta-section-replica {
            flex-direction: column;
            align-items: flex-start;
            gap: 1.5rem;
          }

          .about-button-replica,
          .emergency-contact-replica {
            width: 100%;
          }

          .about-button-replica {
            justify-content: space-between;
          }
        }
      `}</style>

      <section className="about-section-replica" id="about">
        {/* Background Patterns */}
        <div className="triangle-pattern"></div>
        <div className="wave-pattern"></div>

        <div className="about-container-replica">
          {/* Image Collage - Exact Layout */}
          <div className="images-collage-replica">
            {/* Large Left Image */}
            <div className="image-large-left">
              <div className="image-inner">
                <img 
                  src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=700&q=90" 
                  alt="Patient care"
                  className="collage-image-replica"
                />
              </div>
            </div>

            {/* Top Right Image */}
            <div className="image-top-right">
              <div className="image-inner">
                <img 
                  src="https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=700&q=90" 
                  alt="Doctor consultation"
                  className="collage-image-replica"
                />
              </div>
            </div>

            {/* Bottom Left Image */}
            <div className="image-bottom-left">
              <div className="image-inner">
                <img 
                  src="https://images.unsplash.com/photo-1666214280557-f1b5022eb634?w=700&q=90" 
                  alt="Medical equipment"
                  className="collage-image-replica"
                />
              </div>
            </div>

            {/* Large Right Image */}
            <div className="image-large-right">
              <div className="image-inner">
                <img 
                  src="https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=700&q=90" 
                  alt="Surgery team"
                  className="collage-image-replica"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="about-content-replica">
            <div className="about-badge-replica">
              <div className="badge-icon-replica">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              ABOUT VAYU LUNG CARE
            </div>

            <h2 className="about-title-replica">
              Redefining Healthcare Standards with Expert Professionals
            </h2>

            <p className="about-description-replica">
              At VAYU Lung Care, we are dedicated to delivering exceptional healthcare with compassion, innovation, and integrity. For over 15 years, we have been offering comprehensive medical services in Hyderabad.
            </p>

            {/* Video and Features */}
            <div className="video-features-section">
              <div className="video-thumbnail-replica">
                <img 
                  src="https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=400&q=90" 
                  alt="About video"
                />
                <div className="video-play-replica">
                  <Play size={24} fill="#00BCD4" stroke="none" />
                </div>
              </div>

              <div className="features-list-replica">
                <div className="feature-item-replica">
                  <CheckCircle size={24} className="check-icon-replica" stroke="#0A1F44" strokeWidth={2.5} />
                  <span>Expert Medical Professionals</span>
                </div>
                <div className="feature-item-replica">
                  <CheckCircle size={24} className="check-icon-replica" stroke="#0A1F44" strokeWidth={2.5} />
                  <span>Advanced Medical Technology</span>
                </div>
                <div className="feature-item-replica">
                  <CheckCircle size={24} className="check-icon-replica" stroke="#0A1F44" strokeWidth={2.5} />
                  <span>Comprehensive Care Services</span>
                </div>
                <div className="feature-item-replica">
                  <CheckCircle size={24} className="check-icon-replica" stroke="#0A1F44" strokeWidth={2.5} />
                  <span>Neighborhood Clinics</span>
                </div>
                       <div className="feature-item-replica">
                  <CheckCircle size={24} className="check-icon-replica" stroke="#0A1F44" strokeWidth={2.5} />
                  <span>Evening Clinics</span>
                </div>
              </div>
            </div>

            {/* CTA Section */}
            <div className="cta-section-replica">
              <a href="/about" className="about-button-replica">
                <span>About Us</span>
                <div className="arrow-circle">
                  <ArrowRight size={20} />
                </div>
              </a>

              <div className="emergency-contact-replica">
                <div className="phone-icon-wrapper">
                  <Phone size={26} />
                </div>
                <div className="emergency-text-replica">
                  <span className="emergency-label-replica">Emergency Contact</span>
                  <span className="emergency-number-replica">+91 123 456 7890</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSectionExactReplica;